import './ContactPage.css';

const ContactPage = () => {

  return (
    <div>
      {/* Hero Section */}
      <section className="contact-hero">
        <div className="container">
          <h1>Contact Us</h1>
          <p>Get in touch with Spot Free Clarity today</p>
        </div>
      </section>

      {/* Contact Content */}
      <section className="contact-content">
        <div className="container">
          <div className="contact-grid">
            {/* Location Map */}
            <div className="contact-map">
              <div className="info-item">
                <h3>📍 Location</h3>
                <p>Somerset West, Cape, South Africa</p>
                <iframe 
                  title="Spot Free Clarity Location Map"
                  src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3305.935480455955!2d18.7583105!3d-34.0455261!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x67281bc1def66439%3A0x486ad88bac77b6aa!2sSpot%20Free%20Clarity%20Crew%20Window%20%26%20Solar%20Panel%20Cleaning!5e0!3m2!1sen!2suk!4v1765366813888!5m2!1sen!2suk" 
                  width="100%" 
                  height="450" 
                  style={{ border: '0' }}
                  allowFullScreen="" 
                  loading="lazy" 
                  referrerPolicy="no-referrer-when-downgrade"
                ></iframe>
              </div>
            </div>

            {/* Contact Information */}
            <div className="contact-info">
              <div className="info-item">
                <h3>📧 Email</h3>
                <p>
                  <a href="mailto:info@spotfreeclarity.co.za">
                    info@spotfreeclarity.co.za
                  </a>
                </p>
              </div>

              <div className="info-item">
                <h3>📱 Phone</h3>
                <p>
                  +27 (0) 73 981 5595 
                  <br/>
                  WhatsApp <a href="https://wa.me/27739815595" target="_blank" rel="noopener noreferrer">
                  https://wa.me/27739815595
                  </a>
                  <br/><br/>
                  Available for consultations and quotes.
                  <br />
                  We typically respond within 24 hours.
                </p>
              </div>

              <div className="info-item">
                <h3>⏰ Hours</h3>
                <p>
                  Monday - Friday: 7:00 AM - 5:00 PM<br />
                  Saturday: 8:00 AM - 1:00 PM<br />
                  Sunday: Closed
                </p>
              </div>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
};

export default ContactPage;